export interface PushNotificationsState {
  isGranted: boolean;
  isAvailable: boolean;
  token?: string;
}

export interface PushNotificationOptions {
  title?: string;
  body?: string;
}

export enum NotificationType {
  CHATMSG = "2",
  THERAPIST_ASSIGNED = "3",
  VIDEO_CALL = "4",
  ASSIGMENTS_USER_ADDED = "5",
  BREAK_CREATED = "6",
  BREAK_START = "7",
  SCHEDULE_REMINDER = "8",
  ACTIVITY_CENTER_EVENT = "9",
}

interface PAYLOAD {
  "google.delivered_priority"?: string;
  "google.original_priority"?: string;
  img?: string; // https://....
  "thread-id"?: string; // CHATID in several push (EJ: ASSIGNMENTS_USER_ADED)
  category: string;
  type: NotificationType;
  aps?: {
    "thread-id"?: string;
  };
}

export interface CHAT_PAYLOAD extends PAYLOAD {
  role: string; // Chat user role
  type: NotificationType.CHATMSG;
  user: string; // "f9525424-3fae-42f2-a0bd-764a945d67ca;
  ctype: string;
  uname: string; // David Terapeuta
  urole: string; // Chat user role --> sender
  chat: string; // b880cb1aa91447e5b7e6bc953cf683e2
}

export type THERAPIST_ASSIGNED_PAYLOAD = CHAT_PAYLOAD;

export interface VIDEO_CALL_PAYLOAD extends PAYLOAD {
  room_uuid: string; // "a02eabec-1649-4d4c-9da3-174b8fd7416c"
  type: NotificationType.VIDEO_CALL;
  chat: string; // b880cb1aa91447e5b7e6bc953cf683e2
}

export interface ASSIGMENTS_USER_ADDED_PAYLOAD extends PAYLOAD {
  type: NotificationType.ASSIGMENTS_USER_ADDED;
  ctype: 0;
  "thread-id": "";
  uuid: string;
  customer_gender_preference: string;
  sent_at: string;
  created_at: string;
  customer_uuid: string;
  coach_uuid: string;
  therapist_uuid: string;
  customer_gender: string;
  assigned_at: string;
  customer_availability: string;
  customer_area: string;
}

export interface ACTIVITY_CENTER_EVENT_PAYLOAD extends PAYLOAD {
  type: NotificationType.ACTIVITY_CENTER_EVENT;
  "thread-id": "";
  category: string; // "com.nc43tech.activity_center.{event_type_name}"
}

interface OTHER_PAYLOAD extends PAYLOAD {
  [key: string]: unknown;
}

export type NOTIFICATION_DATA =
  | CHAT_PAYLOAD
  | THERAPIST_ASSIGNED_PAYLOAD
  | VIDEO_CALL_PAYLOAD
  | ASSIGMENTS_USER_ADDED_PAYLOAD
  | ACTIVITY_CENTER_EVENT_PAYLOAD
  | OTHER_PAYLOAD;
